// Root (non-tenant) hosts, including feature environments such as app.feature1.seesonar.com.
const NON_SUBDOMAIN_HOSTS =
	/^(?:(?:app|www|app\.feature\d+)\.(?:seesonar|develop-seesonar|staging-seesonar)\.com(?::\d+)?|localhost:\d+)$/u;

export function isSubdomain(url: string): boolean {
	let host: string;

	try {
		// Only the host is checked: a query string can carry other URLs (e.g. an MCP client's
		// redirect_uri=http://localhost:6274/callback) that must not decide the answer.
		({ host } = new URL(url));
	} catch {
		return true;
	}

	return !NON_SUBDOMAIN_HOSTS.test(host);
}
